<template>
  <div class="wrap">
    <div class="wrap-box"
         ref="capture">
      <div class="userHader">
        <div class="urserInfor">
          <div class="userInforIcon">
            <img :src="achData.uIcon"
                 alt
                 v-if="achData.uIcon" />
            <img src="../../assets/images/headericon.png"
                 alt
                 v-else />
          </div>
          <div class="urserInfor-content">
            <span>{{achData.uName}}</span>
            <span>{{getTimes(achData.amCreateDate)}}</span>
          </div>
        </div>
      </div>
      <div class="wrap-title">
        <span>{{achData.vTitle}}</span>
      </div>
      <div class="wrap-list">
        <div>
          <span>
            <b>{{achData.amRank}}</b> 名
          </span>
          <span class="item-name">完成课程排名</span>
          <i class="line1"></i>
        </div>
        <div>
          <span>
            <b>{{achData.amComplete}}</b> 课
          </span>
          <span class="item-name">已完成课程</span>
          <i class="line1"></i>
        </div>
        <div>
          <img src="../../assets/images/erweima.png"
               alt />
          <span class="item-name">CMDHRA</span>
          <span class="item-name">微信公众号</span>
        </div>
      </div>
    </div>
    <div class="wrap-bnt">
      <span @click="save">保存</span>
      <span>分享</span>
    </div>
  </div>
</template>
<script>
import grxx from "../../assets/images/grxx.png";
import woyy from "../../assets/images/woyy.png";
import wdsc from "../../assets/images/wdsc.png";
import next from "../../assets/images/next.png";
import html2canvas from 'html2canvas';
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';
export default {
  data () {
    return {
      uName: null,
      wxuser: null,
      achData: {}
    };
  },
  props: {},
  computed: {},
  async mounted () {
    this.wxuser=await loginService.getLoginUser();
    if(this.wxuser)
    {
      this.uName= this.wxuser.uName;
    }
    
    this.$waiting.hide();

    this.sicon = this.wxuser
      ? this.wxuser.uIcon
        ? this.wxuser.uIcon
        : ""
      : "";
    // console.log(toString(this.wxuser.sIcon));
    // console.log(toString(null));
    document.title = "成就卡";
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    let amUid = this.$route.query.amUid;
    let amVid = this.$route.query.amVid;
    this.info(amUid, amVid);
  },
  methods: {
    info (amUid, amVid) {
      this.$postHttp(AppSetting.baseUrl + "/achievement/app/detail", {
        amUId: amUid,
        amVId: amVid
      }).then(res => {
        if (res.data.code == 0) {
          this.achData = res.data.entity;
          this.$nextTick(() => {
            this.generatorImage();
          })
        }
      });
    },
    save () {
      let link = document.createElement("a");
      link.href = this.dataURL;//下载链接
      link.setAttribute("download", this.achData.vTitle + ".png");
      link.style.display = "none";//a标签隐藏
      document.body.appendChild(link);
      link.click();
    },
    generatorImage () {
      html2canvas(this.$refs.capture, {
        useCORS: true
      }).then(canvas => {
        // this.$refs.addImage.append(canvas);//在下面添加canvas节点
        this.dataURL = canvas.toDataURL("image/png");

      });
    },
    getTimes (value) {
      let val = new Date(value).getTime();
      return new Date(val).Format("yyyy.MM.dd hh:mm");
    }
  }
};
</script>
<style scoped lang="scss">
.wrap {
  min-height: 100vh;
  padding: 0.6rem 0.35rem;
  box-sizing: border-box;
  background: #f4f5f4;
  .wrap-box {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 12px 1px rgba(0, 0, 0, 0.11);
    padding-bottom: 0.54rem;
  }
  .userHader {
    // overflow: hidden;
    font-size: 0.34rem;
    color: #fff;
    background: url("../../assets/images/beijing.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 1.48rem;
    height: 4.41rem;
    .urserInfor {
      width: 100%;
      font-size: 0.36rem;
      color: #333333;
      text-align: center;
      position: absolute;
      top: 3.7rem;
    }
    .userInforIcon {
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 50%;
      margin: auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .urserInfor-content {
      span {
        display: block;
      }
      span:last-child {
        color: #a3a3a3;
        font-size: 0.24rem;
      }
    }
  }
  .wrap-title {
    font-size: 0.28rem;
    color: #333;
    padding: 0px 0.48rem;
    box-sizing: border-box;
  }
  .wrap-list {
    font-size: 0.28rem;
    color: #333;
    display: -webkit-flex;
    display: flex;
    padding: 0px 0.48rem;
    box-sizing: border-box;
    margin-top: 0.61rem;
    div {
      flex: 1;
      text-align: center;
      position: relative;

      .line1 {
        display: inline-block;
        width: 1px;
        height: 0.72rem;
        background: #e5e5e5;
        position: absolute;
        right: 0px;
        top: 0.32rem;
      }
      span {
        display: block;
      }
      b {
        font-size: 0.5rem;
        color: #fc8e2a;
      }
      img {
        display: inline-block;
        width: 0.95rem;
        height: 0.95rem;
      }
    }
    .item-name {
      color: #999999;
      font-size: 0.26rem;
    }
  }
  .wrap-bnt {
    font-size: 0.36rem;
    // padding: 0px 0.48rem;
    box-sizing: border-box;
    overflow: hidden;
    margin-top: 0.72rem;
    span {
      line-height: 0.91rem;
      text-align: center;
      width: 45%;
      border-radius: 0.1rem;
    }
    span:first-child {
      float: left;
      border: 0.02rem solid #05a2ff;
      color: #05a2ff;
    }
    span:last-child {
      float: right;
      background: #05a2ff;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/me/achieveCar.vue